module.exports = __webpack_public_path__ + "static/img/netflix-step2.a10dea2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/netflix-step2.png
// module id = 143
// module chunks = 1